// extracted by mini-css-extract-plugin
export default {"Page":"page_component_Page__ctzGp","Content":"page_component_Content__cCW43","Open":"page_component_Open__D4oh2"};